import { Box, Image } from "@chakra-ui/react";
import React, { Component } from "react";
import Slider from "react-slick";

export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

      autoplaySpeed: 3500,
    };
    // console.log(this.props.autoData);
    const styles = {
      backgroundColor: "green",
      width: "100%",
      borderRadius: "1rem",
    };
    return (
      <Box overflow={"hidden"}>
        <Slider {...settings}>
          {this.props.autoData.map((item) => {
            return (
              <Box key={item.id} o>
                <Image width="auto" src={item.image} style={styles} />
              </Box>
            );
          })}
        </Slider>
      </Box>
    );
  }
}
